import { render, staticRenderFns } from "./DetailRole.vue?vue&type=template&id=d87524f8&scoped=true&"
import script from "./DetailRole.vue?vue&type=script&lang=js&"
export * from "./DetailRole.vue?vue&type=script&lang=js&"
import style0 from "./DetailRole.vue?vue&type=style&index=0&id=d87524f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87524f8",
  null
  
)

export default component.exports